var WeakMap = require('./_WeakMap');

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-tag-input/~/lodash/_metaMap.js
 ** module id = 1208
 ** module chunks = 0
 **/